import React from 'react';
import {
  IconButton,
  useColorMode,
  useColorModeValue,
  Tooltip
} from '@chakra-ui/react';
import { FiSun, FiMoon } from 'react-icons/fi';

interface ColorModeToggleProps {
  variant?: 'solid' | 'outline' | 'ghost';
  size?: 'xs' | 'sm' | 'md' | 'lg';
  isCompact?: boolean;
}

const ColorModeToggle: React.FC<ColorModeToggleProps> = ({
  variant = 'ghost',
  size = 'md',
  isCompact = false
}) => {
  const { colorMode, toggleColorMode } = useColorMode();
  const isDark = colorMode === 'dark';
  
  const iconColor = useColorModeValue('gray.600', 'gray.300');
  const hoverBg = useColorModeValue('gray.100', 'gray.700');
  const tooltipLabel = isDark ? 'Activar modo claro' : 'Activar modo oscuro';
  
  return (
    <Tooltip label={tooltipLabel} placement="bottom">
      <IconButton
        aria-label={tooltipLabel}
        icon={isDark ? <FiSun /> : <FiMoon />}
        onClick={toggleColorMode}
        variant={variant}
        size={size}
        color={iconColor}
        _hover={{
          bg: hoverBg,
          transform: 'scale(1.05)',
        }}
        _active={{
          transform: 'scale(0.95)',
        }}
        transition="all 0.2s ease-in-out"
        borderRadius={isCompact ? 'md' : 'lg'}
      />
    </Tooltip>
  );
};

export default ColorModeToggle; 